import { Icon } from "@iconify-icon/solid";
import { createSignal, For, Show } from "solid-js";
import { Button } from "@/components/shadcn/button"

export const FilterItem = (props) => {
  
  const value = () => {
    if (props.filter.type === 'choice') {
      const texts = props.filter.choices.map((choice) => {
        if (props.value.includes(choice.value)) {
          return choice.text;
        }

        return;
      }).filter((text) => text);

      if (texts.length === 1) {
        return texts[0];
      }

      if (texts.length > 1) {
        return `${texts[0]} (+${texts.length - 1})`;
      }
    }

    if (props.filter.type === 'date') {
      return props.value.format('LL');
    }

    return props.value;
  }
  
  return (
    <div class="flex items-center text-xs font-medium border rounded-md shadow-sm dark:shadow dark:bg-secondary">
      <p class="flex items-center text-gray-400 dark:text-gray-100 gap-2 capitalize px-3 py-1.5">
        <Show when={props.filter.icon}>
          <Icon icon={props.filter.icon} class="me-1" />
        </Show>
        <span>{props.filter.label}</span>
      </p>
      <p class="px-2 border-x text-gray-500 hover:bg-gray-50 dark:hover:bg-zinc-900 cursor-pointer main-transition dark:text-foreground dark:border-border py-1.5">
        Is
      </p>
      <div class="border-r dark:border-border">
        <p class="inline-flex items-center px-2 dark:hover:bg-zinc-900 hover:bg-gray-50 cursor-pointer main-transition dark:text-foreground dark:border-border py-1.5" type="button" aria-haspopup="dialog" aria-expanded="false" aria-controls="radix-:rcj:" data-state="closed">
          {value()}
        </p>
      </div>
      <Button
        variant='ghost'
        class="flex items-center justify-center h-7 w-5 dark:hover:bg-zinc-900 rounded-none rounded-r-md dark:text-foreground"
        onClick={props.onRemove}
      >
        <Icon icon="ion:close" />
      </Button>
    </div>
  );
}
